export default __webpack_public_path__ + "static/media/crossSectionGenericTemp.5064213a.png";